import * as React from "react";
import styled from "styled-components";

interface IProps {
  title: string;
  children?: React.ReactNode;
}
// Header section for chart header which includes title
// Should send children to render (i.e. dropdown)
export const ChartHeader = ({ title, children }: IProps) => {
  return (
    <ChartHeaderContainer>
      <ChartHeaderTitle> {title} </ChartHeaderTitle>
      {children && <DatePickerContainer>{children}</DatePickerContainer>}
    </ChartHeaderContainer>
  );
};

const ChartHeaderContainer = styled.div`
  width: 95%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 15px;
  margin: 10px;
`;

export const DatePickerContainer = styled.div`
  width: 240px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding-top: 15px;
`;

export const ChartHeaderTitle = styled.span`
  font-size: 20px;
`;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/ChartHeader.tsx